export default "__VITE_ASSET__jY54pnN1__"